export default
  data: ->
    plusPoint: null
  methods:
    activatePlusTools: (plusPoint) ->
      @plusPoint = plusPoint
    removePlusTools: ->
      @plusPoint = null